/**
 * Provider IDs that only return data inside the United States.
 *
 * Content-Source Fixes Prompt 14 — when the dispatcher detects a non-US site,
 * these providers are skipped entirely (no upstream call) and their slot in
 * the SED is stamped `unavailable: { reason: 'non-us-coverage' }`. Calling
 * these upstream APIs from outside the US burns a budget against either a
 * 404, a 401, or silent empty-set data — none of which is useful.
 *
 * P1.8 (2026-09-05) — lifted out of `services/dataProviders/index.ts` (which
 * re-exports it unchanged) into a dependency-free leaf so the enqueue-time
 * territory guard (`lib/audit/territoryGate.ts`) can read the SAME list the
 * dispatcher skips on. The platform is US-only by design for now; that
 * limitation lives in this list plus the provider fallback chains, and the
 * territory guard is the one named place that turns it into a clear refusal.
 */
export const US_ONLY_PROVIDER_IDS = [
  'hifld-grid',
  'fema-flood',
  'usfws-env',
  'nrel-solar',
  'nrel-wind',
  'eia-electricity',
  'eia-natural-gas',
  'airnow-aqi',
  'nrc-reactors',
  'nrc-adams',
  'regulatory-db',
  'epa-attainment',
  'nrcs-soil-survey',
  'jurisdiction-boundaries',
  'usgs-mrds',
  'nps-nrhp',
  // RD-1 (D) — refdata-only national snapshots (US coverage by definition).
  'epa-frs',
  'usgs-waters',
  'padus-protected',
  'census-aiannh',
] as const;

export const US_ONLY_PROVIDER_ID_SET: ReadonlySet<string> = new Set(US_ONLY_PROVIDER_IDS);
